import { useEffect, useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import { usePostpicklistMutation } from "../../../../../store/api/picklist";
import ActionButtonDropdown from "../../../../../Components/ActionButtonDropdown";
import Pagination from "../../../../../Core/Pagination/Pagination";
import ListLayout from "../../../../../Core/Layout/ListLayout";
import Table from "../../../../../Core/Table/Table";
import Tabs from "../../../../../Components/Tabs";
import ConfigureColumnsNew from "../../../../../Core/ConfigureColumnsNew/ConfigureColumnsNew";
import ExportCSV from "../../../../../Core/Export/ExportCSV";
import ListFilters from "../../../../../Core/ListFilters/ListFilters";
import { useDeleteDocMutation } from "../../../../../store/api/globalapi";
import DelConfirmPopup from "../../../../../Components/Popup/DelConfirmPopup ";
import useScreenHeight from "../../../../../utils/useScreenHeight";

const Lpntable = () => {
    const navigate = useNavigate();
    const { screenHeight, screenScaling , pageSize} = useScreenHeight();

    const [filters, setFilters] = useState({});
    const [loading, setLoading] = useState(true);
    const [currentPage, setCurrentPage] = useState(1);
    const [pickListData, setPickListData] = useState({ pick_lists: [], total_no_of_records: 0 });
    const [pickListDataApi] = usePostpicklistMutation();
    const [showExportPopup, setShowExportPopup] = useState(false);
    const [showColumnConfig, setShowColumnConfig] = useState(false);
    const [showFilters, setShowFilters] = useState(false);
    const [deleteDoc] = useDeleteDocMutation();

const filtersConfig = [
    { name: 'siNo', label: 'S. No.', width: '6%', type: 'text' },
    { name: 'name', label: 'Pick List Id', width: '15%', type: 'text' },
    { name: 'sales_order_no', label: 'Sales Order No', width: '14%', type: 'text' },
    { name: 'customer', label: 'Customer', width: '15%', type: 'text' },
    { name: 'no_of_line', label: 'No. of Lines', type: 'number', width: '12%' },
    { name: 'total_qty', label: 'Total Quantity', type: 'number', width: '12%' },
    { name: 'total_picked_qty', label: 'Total Picked Qty', type: 'number', width: '13%' },
    { name: 'delivery_note', label: 'Delivery Note', type: 'text', width: '14%' },
    { name: 'company', label: 'Company', type: 'text', width: '12%' },
    { name: 'created_by', label: 'Created By', type: 'text', width: '12%' },
    { name: 'modified_by', label: 'Modified By', type: 'text', width: '12%' },
    { name: 'purpose', label: 'Purpose', type: 'text', width: '10%' },
    {
        name: 'status',
        label: 'Status',
        width: '13%',
        type: 'select',
        options: [
            { value: 'Submitted', label: 'Submitted' },
            { value: 'Draft', label: 'Draft' },
            { value: 'Delivery Note Submitted', label: 'Delivery Note Submitted' },
            { value: 'Delivery Note Created', label: 'Delivery Note Created' }
        ]
    },
    { name: 'date_range', label: 'Date Range', type: 'date-range', width: '12%' }
];


  const [columnsConfig, setColumnsConfig] = useState(() => [
  {
    header: "S. No.",
    name: "S. No.",
    accessor: "siNo",
    width: '72px',
    cellRenderer: (row) => row.siNo,
    sortable: false,
    visible: true,
  },
  {
    header: "Pick List Id",
    name: "Pick List Id",
    accessor: "name",
    width: '180px',
    sortable: true,
    visible: true,
  },
  {
    header: "Sales Order No",
    name: "Sales Order No",
    accessor: "sales_order_no",
    width: '160px',
    sortable: true,
    visible: false,
  },
  {
    header: "Customer",
    name: "Customer",
    accessor: "customer",
    width: '180px',
    sortable: true,
    visible: true,
  },
  {
    header: "No. of Lines",
    name: "No. of Lines",
    accessor: "no_of_line",
    width: '144px',
    sortable: true,
    visible: true,
    sortFn: (a, b) => parseInt(a.no_of_line) - parseInt(b.no_of_line),
  },
  {
    header: "Total Quantity",
    name: "Total Quantity",
    accessor: "total_qty",
    width: '144px',
    sortable: true,
    visible: true,
    sortFn: (a, b) => parseInt(a.total_qty) - parseInt(b.total_qty),
  },
  {
    header: "Total Picked Qty",
    name: "Total Picked Qty",
    accessor: "total_picked_qty",
    width: '156px',
    sortable: true,
    visible: true,
    sortFn: (a, b) => parseInt(a.total_picked_qty) - parseInt(b.total_picked_qty),
  },
  {
    header: "Delivery Note",
    name: "Delivery Note",
    accessor: "delivery_note",
    width: '160px',
    sortable: true,
    visible: false,
  },
  {
    header: "Company",
    name: "Company",
    accessor: "company",
    width: '144px',
    sortable: true,
    visible: false,
  },
  {
    header: "Created By",
    name: "Created By",
    accessor: "created_by",
    width: '144px',
    sortable: true,
    visible: false,
  },
  {
    header: "Modified By",
    name: "Modified By",
    accessor: "modified_by",
    width: '144px',
    sortable: true,
    visible: false,
  },
  {
    header: "Purpose",
    name: "Purpose",
    accessor: "purpose",
    width: '120px',
    sortable: true,
    visible: false,
  },
  {
    header: "Assigned To",
    name: "Assigned To",
    accessor: "assigned_to",
    width: '144px',
    sortable: false,
    visible: false,
    cellRenderer: (row) => (
      <span>
        {row.assigned_to && row.assigned_to.length > 0
          ? row.assigned_to.join(', ')
          : "—"}
      </span>
    ),
  },
  {
    header: "Status",
    name: "Status",
    accessor: "status",
    width: '156px',
    sortable: true,
    visible: true,
    cellRenderer: (row) => {
      const status = row.status;
      let color;

      switch (status) {
        case 'Submitted':
          color = '#65A30D';
          break;
        case 'Draft':
          color = '#6366F1';
          break;
        case 'Delivery Note Submitted':
          color = '#0E7490';
          break;
        case 'Delivery Note Created':
          color = '#F97316';
          break;
        default:
          color = '#000000';
      }

      return (
        <span
          style={{
            backgroundColor: `${color}1A`,
            color,
            padding: '4px 10px',
            borderRadius: '9999px',
            fontSize: '12px',
            fontWeight: 500,
            display: 'inline-block',
            textTransform: 'capitalize',
          }}
        >
          {status}
        </span>
      );
    },
  },
  {
    header: "Date",
    name: "Date",
    accessor: "creation",
    width: '120px',
    sortable: true,
    visible: true,
    sortFn: (a, b) => new Date(a.creation) - new Date(b.creation),
  },
  {
    header: "Action",
    name: "Action",
    accessor: "action",
    width: '120px',
    sortable: false,
    visible: true,
    cellRenderer: (row) => (
      <ActionButtonDropdown
        id={row.name}
        onView={() => handleView(row.name)}
        onEdit={() => handleEdit(row.name)}
        onDelete={() => handleDelete(row.name)}
      />
    ),
  },
]);


    const handleSaveColumns = (selectedKeys) => {
        const updatedColumns = columnsConfig.map(column => ({
            ...column,
            visible: selectedKeys.includes(column.accessor)
        }));
        setColumnsConfig(updatedColumns);
    };

    const visibleColumns = useMemo(() =>
        columnsConfig.filter(col => col.visible), [columnsConfig]);

    const defaultSelectedColumns = useMemo(() =>
        columnsConfig
            .filter(col => col.visible)
            .map(col => ({
                fieldname: col.accessor,
                label: col.name
            })), [columnsConfig]);
    const handleFilterChange = (newFilters) => {
			setCurrentPage(1);
			setFilters(newFilters);
		};

    const handleView = (id) => navigate(`/outbound/pick/pick-view/`, { state: { pick_id: id } });
    const handleEdit = (id) => navigate(`/outbound/pick/pick-edit/`, { state: { pick_id: id } });
    const [delPopupVisible, setDelPopupVisible] = useState(false);
    const [delSelectedId, setDelSelectedId] = useState(null);
    const [delmessage, setDelmessage] = useState();
    const [alreadySubmitData, setAlreadySubmitData] = useState(false)
    const [delDone, setDelDone] = useState(false)

    const handleDelete = (id) => {
        setDelSelectedId(id);
        setDelPopupVisible(true)
        setAlreadySubmitData(false)
        setDelmessage("Are you sure you want to Delete this Pick List?");
    };

    const delHandleCancel = () => {
        setDelPopupVisible(false);
        setDelSelectedId(null);
    }

    const delHandleConfirm = async () => {
        
        try {
            await deleteDoc({ doctype: "Pick List", name: delSelectedId }).unwrap()
            setDelmessage(`Pick List ${delSelectedId} deleted successfully!`)
            setDelDone(true)
            setTimeout(() => {
                setDelPopupVisible(false);
                setDelDone(false)
                getData();
            }, 1000);
        } catch (err) {
            console.error("Deletion Failed:", err)

            let errorMessage = "Failed to delete the Pick List!";

            //If the server is sending the error message , we will extract it.
            if (err?.data?._server_messages) {
                try {
                    const messageArr = JSON.parse(err.data._server_messages)
                    if (messageArr && messageArr.length > 0) {
                        //parse inner json object
                        const messageObj = JSON.parse(messageArr[0])
                        if (messageObj?.message) {
                            //extract the exact message we want
                            const fullMessage = messageObj.message
                            errorMessage = fullMessage.trim();
                            //remove html in the message
                            errorMessage = errorMessage.replace(/<[^>]+>/g, '');

                        }
                    }
                } catch (parseError) {
                    console.error("Error parsing server messages:", parseError);
                }
            }
            setDelPopupVisible(true)
            setDelmessage(errorMessage)
            setAlreadySubmitData(true);
        } finally {
            // setTimeout(() => {
            //     setDelPopupVisible(false);
            //     setDelSelectedId(null);
            // }, 2000);
        }
    };
    const activeFilterCount = useMemo(() => {
        return Object.values(filters).filter(val => val !== null && val !== undefined && val !== '').length;
    }, [filters]);
    const actionButtons = [
			{
				className: "createbtn border-0 d-flex",
				style: { gap: "2px", height: "28px" },
				iconName: "IoFilterSharp",
				iconSize: 12,
				children:
					activeFilterCount > 0 ? `Filter (${activeFilterCount})` : "Filter",
				onClick: () => {
					setShowFilters((prev) => !prev);
					setShowColumnConfig(false);
				},
			},
			{
				className: "btnsecond border-0 d-flex",
				style: { gap: "2px", height: "28px" },
				iconName: "MdOutlineRemoveRedEye",
				iconSize: 12,
				children: "Show more",
				onClick: () => {
					setShowColumnConfig((prev) => !prev);
					setShowFilters(false);
				},
			},
			{
				className: "btnthird border-0 d-flex",
				style: { gap: "2px", height: "28px" },
				iconName: "RiFileExcel2Fill",
				iconSize: 12,
				children: "Export Excel",
				onClick: () => setShowExportPopup(true),
			},
			{
				className: "custom-btn-00989 d-flex",
				to: "/outbound/pick/createpick",
				iconName: "FiPlus",
				style: { gap: "2px", height: "28px" },
				children: "Create Pick List",
			},
		];

    const getData = async () => {
        setLoading(true);
        try {
					const filteredSearchInput = Object.entries(filters).reduce(
						(acc, [key, value]) => {
							if (value !== "" && value !== undefined && value !== null) {
								acc[key] = value;
							}
							return acc;
						},
						{}
					);
					const siNoFilter = filteredSearchInput.siNo;
					const isSiNoFilterActive =
						siNoFilter !== undefined && siNoFilter !== "";
					// STEP 3: If filtering by siNo, jump to that page
					const targetPage = isSiNoFilterActive
						? Math.ceil(parseInt(siNoFilter, 10) / pageSize)
						: currentPage;
					const payload = {
						start: pageSize * (targetPage - 1),
						page_length: pageSize,
						...(Object.keys(filteredSearchInput).length > 0 && {
							search_input: {
								pick_list_name: filteredSearchInput.name || "",
								customer_name: filteredSearchInput.customer || "",
								status: filteredSearchInput.status || "",
								date_range: filteredSearchInput.date_range || "",
								min_total_qty: filteredSearchInput.total_qty || "",
								max_total_qty: filteredSearchInput.total_qty || "",
								min_no_of_line: filteredSearchInput.no_of_line || "",
								max_no_of_line: filteredSearchInput.no_of_line || "",
							},
						}),
            filters:[["Pick List","work_order","is","not set"]]
					};

					const response = await pickListDataApi(payload);
					const rawData = response.data.data.pick_lists;
					// STEP 4: Assign global serial numbers
					const numberedData = rawData.map((item, index) => ({
						...item,
						siNo: index + 1 + pageSize * (targetPage - 1),
					}));

					// STEP 5: If siNo is used, filter client-side
					const finalData = isSiNoFilterActive
						? numberedData.filter(
								(item) => item.siNo === parseInt(siNoFilter, 10)
						  )
            : numberedData;
          
          setPickListData({
            pick_lists: finalData || [],
            total_no_of_records: response.data?.data?.total_no_of_records || 0
          });
				} catch (error) {
            console.error("Error fetching pick lists:", error);
        } finally {
            setLoading(false);
        }
    };



  useEffect(() => {
    if(pageSize > 0)
      getData();
    
	}, [currentPage, filters, pageSize, screenHeight, screenScaling]);
  const accessors = [
      "name",
      // "sales_order_no",
      "customer",
      // "no_of_line",
      // "total_qty",
      // "total_picked_qty",
      // "delivery_note",
      "company",
      // "created_by",
      "modified_by",
      "purpose",
      // "assigned_to",
      "status",
      "creation"
    ];
    return (
        <div className="container-fluid d-flex flex-column" style={{ flexGrow: '1' }}>
            <Tabs />
            <ListLayout
                breadcrumbItems={[
                    { label: "Outbound" },
                    { label: "Pick List", style: { color: '#4b002b' } }
                ]}
                actionButtons={actionButtons}
            >
                {showFilters && (
                    <ListFilters
                        filtersConfig={filtersConfig}
                        onFilterChange={handleFilterChange}
                        currentFilters={filters}
                        setShowFilters={setShowFilters}
                    />
                )}

                {showColumnConfig && (
                    <ConfigureColumnsNew
                        show={showColumnConfig}
                        onClose={() => setShowColumnConfig(false)}
                        onSave={handleSaveColumns}
                        docType="Pick List"
                        defaultSelected={defaultSelectedColumns}
                        fieldsData={columnsConfig.map(col => ({
                            fieldname: col.accessor,
                            label: col.name
                        }))}
                        disabledFields={["siNo","name", "status","creation", "action"]}
                    />
                )}

                <Table
                    columns={visibleColumns}
                    data={pickListData.pick_lists}
                    loading={loading}
                />

                <Pagination
                    setCurrentPage={setCurrentPage}
                    pageSize={pageSize}
                    totalRecords={pickListData.total_no_of_records}
                    currentPage={currentPage}
                    className="mt-2 pb-3"
                />
                {delPopupVisible &&
                    <DelConfirmPopup
                        alredysubmitdata={alreadySubmitData}
                        delSelectedId={delSelectedId}
                        visible={delPopupVisible}
                        message={delmessage}
                        onConfirm={delHandleConfirm}
                        onCancel={delHandleCancel}
                        delDone={delDone}
                    />}
                {showExportPopup && (
                    <ExportCSV
                      doctype="Pick List"
                      fieldsData={accessors}
                      onClose={() => setShowExportPopup(false)}
                    />
                )}
            </ListLayout>
        </div>
    );
};

export default Lpntable;
